export default "__VITE_ASSET__ByrFxZ37__"